<template>
  <div>
    <div class="row my-4">
      <div class="col-8">
        <Header
          title="Campaign Details"
          :is-link="true"
          :link="landingTab"
        />
      </div>
      <div
        v-if="campaign.projectId"
        class="col-4 text-right"
      >
        <span class="mr-3">
          <a
            v-if="campaign.hasTemplate && campaign.subject"
            id="SendToTestEmails"
            href="#"
            @click="onSendTest"
          >
            <font-awesome-icon
              :icon="['far', 'paper-plane']"
              size="lg"
              class="mr-2"
            />Send Test
          </a>
          <span v-if="!campaign.hasTemplate || !campaign.subject">
            <font-awesome-icon
              :icon="['far', 'paper-plane']"
              size="lg"
              class="mr-2"
            />Send Test
          </span>
        </span>
        <ejs-dropdownbutton
          ref="actionsDropdown"
          :key="itemsKey"
          :items="items"
          css-class="e-caret-hide grid-action px-0"
          :select="onSelect"
          :open="onOpen"
        >
          <button class="btn btn-lg btn-primary px-4">
            Actions <font-awesome-icon
              :icon="['far', 'chevron-down']"
              size="xs"
              class="ml-2"
            />
          </button>
        </ejs-dropdownbutton>
      </div>
    </div>
    <ul
      v-if="campaign.projectId"
      class="nav nav-tabs"
    >
      <li class="nav-item">
        <router-link
          class="nav-link"
          :to="{name: 'CampaignDetailsSummary', query: campaignQuery }"
        >
          Summary
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          :to="{name: 'CampaignDetailsPreview', query: campaignQuery }"
        >
          Preview
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          v-if="campaign.hasTemplate && campaign.subject"
          class="nav-link"
          :to="{name: 'CampaignDetailsTesting', query: campaignQuery }"
        >
          Testing
        </router-link>
        <a
          v-if="!campaign.hasTemplate || !campaign.subject"
          href="#"
          class="nav-link disabled"
        >Testing</a>
      </li>
      <li
        v-if="campaign && !campaign.isSubProject"
        class="nav-item"
      >
        <router-link
          class="nav-link"
          :to="{name: 'CampaignDetailsAudience', query: campaignQuery }"
        >
          Audience
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          class="nav-link"
          :to="{name: 'CampaignDetailsHistory', query: campaignQuery }"
        >
          History
        </router-link>
      </li>
      <li
        v-if="campaign && !campaign.isSubProject"
        class="nav-item"
      >
        <router-link
          class="nav-link"
          :to="{name: 'CampaignDetailsReport', query: campaignQuery }"
        >
          Report
        </router-link>
      </li>
    </ul>
    <div class="tab-content">
      <router-view />
    </div>
    <ejs-dialog
      id="dialog"
      ref="dialogTemplate"
      :target="target"
      :is-modal="true"
      :height="height"
      :width="width"
      :show-close-icon="false"
      :content="dialogTemplate"
      :overlay-click="closeDialog"
      :visible="false"
      :animation-settings="animationSettings"
    />
    <ejs-dialog
      id="deleteDialog"
      ref="deleteDialogTemplate"
      :target="target"
      :is-modal="true"
      :height="height"
      :width="width"
      :show-close-icon="false"
      :content="deleteDialogTemplate"
      :overlay-click="closeDialog"
      :visible="false"
      :animation-settings="animationSettings"
    />
    <ejs-toast
      ref="infoToast"
      :position="{ X: 'Right', Y: 'Top' }"
      :animation="infoToastAnimation"
      show-close-button="false"
    />
    <ejs-toast
      ref="toastItem"
      :position="{ X: 'Right', Y: 'Top' }"
      show-close-button="true"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import Header from '../components/Header.vue'
import { iframeParentCommunication } from '../mixins/iframeParentCommunication'
import { mapState, mapGetters } from 'vuex'

const dialogTemplate = Vue.component('DialogTemplate', {
  data () {
    return {
      eInsightUrl: {},
      dialogStyle: {
        textAlign: 'center',
        padding: '20px 0'
      }
    }
  },
  methods: {
    cancel () {
      this.$parent.$parent.closeDialog()
    },
    editCampaign () {
      this.$parent.$parent.editCampaign()
    }
  },
  template: `
    <div>
      <div class="dialogContent" v-bind:style="dialogStyle" > 
        <h2>Confirm</h2></br>
         <p>This project has already been scheduled.<br />
          Saving any changes to the Audience or Template will delete the existing schedule.</p>
        <button @click="cancel" class="btn btn-lg btn-outline-secondary">Cancel</button>
        <button @click="editCampaign" class="btn btn-lg btn-danger">Ok</button>
      </div>
    </div>`
})

const deleteDialogTemplate = Vue.component('DeleteDialogTemplate', {
  data () {
    return {
      eInsightUrl: {},
      dialogStyle: {
        textAlign: 'center',
        padding: '20px 0'
      }
    }
  },
  methods: {
    cancel () {
      this.$parent.$parent.closeDeleteDialog()
    },
    deleteCampaign () {
      this.$parent.$parent.deleteCampaign()
    }
  },
  template: `
    <div>
      <div class="dialogContent" v-bind:style="dialogStyle" > 
        <h2>Delete Confirmation</h2></br>
         <p>Are you sure you wish to delete the campaign?<br /><br />
         This action cannot be undone.</p>
        <button @click="cancel" class="btn btn-lg btn-outline-secondary">Cancel</button>
        <button @click="deleteCampaign" class="btn btn-lg btn-danger">Ok</button>
      </div>
    </div>`
})

export default {
  components: {
    Header
  },
  mixins: [iframeParentCommunication],
  data () {
    return {
      savingAsTemplate: false,
      infoToastAnimation: {
        show: {
          effect: 'FadeIn',
          duration: 300,
          easing: 'linear'
        },
        hide: {
          effect: 'FadeOut',
          duration: 0,
          easing: 'linear'
        }
      },
      toastKey: 'random3873',
      itemsKey: 'random123',
      items: [
        { text: 'Edit', id: 'edit' },
        { text: 'Clone', id: 'clone' },
        { text: 'Delete', id: 'delete' },
        { separator: true },
        { text: 'Save as Resend', id: 'addResend' },
        { text: 'Save as Template', id: 'addTemplate' }
      ],
      campaignQuery: {
        clientId: this.$route.query.clientId,
        companyId: this.$route.query.companyId,
        campaignId: this.$route.query.campaignId,
        userEmail: this.$route.query.userEmail
      },
      target: '#app',
      height: '',
      width: '400px',
      animationSettings: { effect: 'Fade', duration: 100 },
      dialogTemplate () {
        return {
          template: dialogTemplate
        }
      },
      deleteDialogTemplate () {
        return {
          template: deleteDialogTemplate
        }
      }
    }
  },
  computed: {
    ...mapState({
      campaign: state => state.manageCampaigns.campaign.summaryDetails,
      userAccessControl: state => state.manageCampaigns.userAccessControl
    }),
    ...mapGetters({
      landingTab: 'getLandingTab',
      accountId: 'getAccountId'
    })
  },
  watch: {
    items () {
      this.itemsKey = this.randomKey()
    }
  },
  mounted () {
    if (!this.userAccessControl.SaveAsResend) {
      this.items = this.items.filter(element => element.id !== 'addResend')
    }
  },
  methods: {
    randomKey (name = 'random') {
      return name + (Math.floor(Math.random() * 100) + 1)
    },
    showGeneralErrorMsg () {
      this.$refs.infoToast.hide()
      this.$refs.toastItem.show({ content: 'An error has occurred while processing your request. Please contact producthelp@cendyn.com for assistance.', cssClass: 'notification-error', width: 300 })
    },
    showUnableMsg () {
      this.$refs.infoToast.hide()
      this.$refs.toastItem.show({ content: 'Unable to save as template.<br>Convert template into Studio Editor in order to save.', cssClass: 'notification-error', width: 355 })
    },
    showNoAssociationMsg () {
      this.$refs.infoToast.hide()
      this.$refs.toastItem.show({ content: 'There is no template associated to save.', cssClass: 'notification-error', width: 300 })
    },
    onSelect (args) {
      let uri = ''
      let data = { action: 'eIn_redirect', value: uri }
      if (this.campaign.projectId) {
        if (args.item.text === 'Edit') {
          if (this.campaign.statusCampaignTranslated === 'Scheduled Active' || this.campaign.statusCampaignTranslated === 'Scheduled Inactive') {
            this.$refs.dialogTemplate.show()
          } else {
            uri = '/Project.mvc/Project/Edit?projectId=' + this.campaign.projectId + '#template'
            data = { action: 'eIn_redirect', value: uri }
            this.SendMessageToParent(data)
          }
        } else if (args.item.text === 'Clone') {
          data = { action: 'eIn_clone_campaign', value: this.campaign.projectId }
          this.SendMessageToParent(data)
        } else if (args.item.text === 'Delete') {
          this.$refs.deleteDialogTemplate.show()
          // uri = '/Project.mvc/Project/Cancel?projectId=' + this.campaign.projectId
          // data = { action: 'eIn_redirect', value: uri }
          // this.SendMessageToParent(data)
        } else if (args.item.text === 'Save as Resend') {
          data = {
            action: 'eIn_save_as_resend',
            value: {
              companyId: this.campaign.companyID,
              projectId: this.campaign.projectId,
              title: this.campaign.title
            }
          }
          this.SendMessageToParent(data)
        } else if (args.item.text === 'Save as Template') {
          if (this.savingAsTemplate || !this.accountId) return
          this.savingAsTemplate = true
          this.$store.dispatch('getCampaignTemplate', { projectId: this.$route.query.campaignId, userEmail: atob(this.$route.query.userEmail) })
            .then(res => {
              if (res.error) {
                this.showGeneralErrorMsg()
              } else if (res.data) {
                const currentChildTemplate = res.data
                if (currentChildTemplate.editorTypeId === 1) {
                  if (currentChildTemplate.htmlJson === null || currentChildTemplate.styleJson === null) {
                    this.savingAsTemplate = false
                    if (currentChildTemplate.html.length) {
                      this.showUnableMsg()
                    } else {
                      this.showNoAssociationMsg()
                    }
                    return
                  }
                }
                this.$refs.infoToast.show({ content: 'Saving as template...', cssClass: 'notification-info', width: 300 })
                const data = JSON.parse(JSON.stringify(currentChildTemplate))
                data.name = `Saved from ${this.campaign.title}`
                data.description = data.description ?? ''
                data.accountIds = [this.accountId]
                data.editorTypeId = currentChildTemplate.editorTypeId
                data.culture = 'en-US'
                data.projectId = this.campaign.projectId
                data.tags = []

                // If the editor type is drag N drop editor passing the html as htmlJson so template builder editor can correctly open it
                if (currentChildTemplate.editorTypeId === 2) {
                  data.htmlJson = JSON.stringify([data.beeFreeJson])
                } else {
                  if (Object.prototype.hasOwnProperty.call(data, 'beeFreeJson')) {
                    delete data.beeFreeJson
                  }
                }

                this.$store.dispatch('addTemplate', { userEmail: atob(this.$route.query.userEmail), data })
                  .then(res => {
                    if (res.error) {
                      this.showGeneralErrorMsg()
                    } else {
                      this.$refs.infoToast.hide()
                      this.$refs.toastItem.show({ content: `Your template "${data.name}" was saved successfully.`, cssClass: '', width: 300 })
                    }
                    this.savingAsTemplate = false
                  })
                  .catch(err => {
                    this.savingAsTemplate = false
                    this.showGeneralErrorMsg()
                    console.log(err)
                  })
              } else {
                this.savingAsTemplate = false
                this.showNoAssociationMsg()
              }
            })
            .catch(err => {
              this.savingAsTemplate = false
              this.showGeneralErrorMsg()
              console.log(err)
            })
        } else {
          uri = '/Project.mvc/Project/ManageCampaigns'
          const data = { action: 'eIn_redirect', value: uri }
          this.SendMessageToParent(data)
        }
      }
    },
    onOpen (args) {
      args.element.parentElement.style.marginLeft = '-20px'
      if (!this.userAccessControl.SaveAsTemplate) {
        args.element.childNodes[5].remove()
      }
      if (!this.userAccessControl.SaveAsResend) {
        args.element.childNodes[4].remove()
      }
      if (!this.userAccessControl.SaveAsTemplate && !this.userAccessControl.SaveAsResend) {
        args.element.childNodes[3].remove()
      }
    },
    onSendTest (args) {
      const data = { action: 'eIn_send_test', value: this.$route.query.campaignId }
      this.SendMessageToParent(data)
    },
    openDialog () {
      this.$refs.dialogTemplate.show()
    },
    closeDialog () {
      this.$refs.dialogTemplate.hide()
    },
    editCampaign () {
      const uri = '/Project.mvc/Project/EditSchedule?projectId=' + this.campaign.projectId + '#template'
      const data = { action: 'eIn_redirect', value: uri }
      this.SendMessageToParent(data)
      this.$refs.dialogTemplate.hide()
    },
    openDeleteDialog () {
      this.$refs.deleteDialogTemplate.show()
    },
    closeDeleteDialog () {
      this.$refs.deleteDialogTemplate.hide()
    },
    deleteCampaign () {
      this.$store.dispatch('deleteCampaign', { projectId: this.campaign.projectId, userEmail: atob(this.$route.query.userEmail), clientId: this.$route.query.clientId, companyId: this.campaign.companyID })
      this.$refs.deleteDialogTemplate.hide()
      this.SendMessageToParent({ action: 'eIn_redirect', value: '/Project.mvc/Project/ManageCampaigns' })
    }
  }
}
</script>

<style lang="scss" scoped>
.mr-3 {
  line-height: 34px;
  vertical-align: middle;
}
</style>
